import { Text } from "@chakra-ui/react";
import { Search } from "lucide-react";
import { formatChordLabel, shortcutById } from "~/app/shortcuts";
import { Button } from "~/components/ui/button";
import { COMPACT_PRESS_AREA } from "~/components/ui/icon-button";
import { iconSize } from "~/components/ui/icon-size";
import { Kbd } from "~/components/ui/kbd";
import { useCommandBar } from "./CommandBarContext";
import { getIsMac } from "./utils/platform";
/**
 * Search in the top bar: a 28px secondary control that opens the command
 * palette, with its key from the shortcuts map shown beside it (⌘K on a Mac,
 * Ctrl+K elsewhere). Below 768 it folds to its icon.
 *
 * Spec: specs/design-system/ledger-shell.feature
 */
export function CommandBarTrigger() {
  const { open } = useCommandBar();
  const shortcut = formatChordLabel({
    chord: shortcutById("palette").keys[0] ?? "Mod+K",
    isMac: getIsMac(),
  });

  return (
    <Button
      aria-label="Open command bar"
      aria-keyshortcuts="Control+K Meta+K"
      variant="outline"
      size="sm"
      paddingX="var(--space-2)"
      color="var(--color-fg-2)"
      fontWeight="normal"
      gap="var(--space-2)"
      flexShrink={0}
      onClick={open}
      {...COMPACT_PRESS_AREA}
    >
      <Search style={iconSize.sm} aria-hidden />
      <Text as="span" display={{ base: "none", md: "inline" }}>
        Search
      </Text>
      <Kbd display={{ base: "none", md: "inline-flex" }}>{shortcut}</Kbd>
    </Button>
  );
}
